import { token } from '@atlaskit/tokens';

type IconProps = {
	width?: string | number;
	height?: string | number;
};

export const GithubIcon = ({ width = '28', height = '28' }: IconProps) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 22 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_1109_48075)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M11.019 0.412109C5.13963 0.412109 0.37207 5.2589 0.37207 11.238C0.37207 16.0211 3.42274 20.0791 7.65308 21.5106C8.18518 21.6108 8.38053 21.2758 8.38053 20.9898C8.38053 20.7317 8.37066 19.8789 8.36608 18.9743C5.40409 19.6291 4.77908 17.697 4.77908 17.697C4.29476 16.4456 3.59693 16.1129 3.59693 16.1129C2.63093 15.441 3.66974 15.4548 3.66974 15.4548C4.73888 15.5312 5.30183 16.5704 5.30183 16.5704C6.25143 18.2254 7.79254 17.747 8.4001 17.4704C8.49566 16.7707 8.77158 16.2931 9.07607 16.0227C6.71124 15.749 4.22529 14.8207 4.22529 10.6725C4.22529 9.49061 4.6412 8.52487 5.32228 7.76673C5.21174 7.49406 4.84731 6.39297 5.42542 4.90179C5.42542 4.90179 6.31948 4.61083 8.35408 6.01148C9.20336 5.77162 10.1142 5.65133 11.019 5.6472C11.9238 5.65133 12.8353 5.77162 13.6862 6.01148C15.7183 4.61083 16.6111 4.90179 16.6111 4.90179C17.1907 6.39297 16.8261 7.49406 16.7155 7.76673C17.3982 8.52487 17.8113 9.49061 17.8113 10.6725C17.8113 14.8306 15.3206 15.7461 12.9497 16.0141C13.3316 16.3501 13.6719 17.0089 13.6719 18.0189C13.6719 19.4674 13.6596 20.6332 13.6596 20.9898C13.6596 21.2779 13.8512 21.6155 14.3909 21.5092C18.6189 20.0761 21.6657 16.0195 21.6657 11.238C21.6657 5.2589 16.8989 0.412109 11.019 0.412109Z"
					fill={token('color.icon')}
				/>
			</g>
			<defs>
				<clipPath id="clip0_1109_48075">
					<rect
						width="21.3333"
						height="21.3333"
						fill={token('color.icon.inverse')}
						transform="translate(0.333496 0.333008)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
